declare var GridStack: any;

namespace Matrix.Dashboards {

    const dashboardTableFields = {
        [DashboardRow.Fields.DashboardCode]: true,
        [DashboardRow.Fields.Name]: true,
        [DashboardRow.Fields.CategoryCode]: true,
        [DashboardRow.Fields.Data]: true,
        [DashboardRow.Fields.DefaultForRoles]: true,
        [DashboardRow.Fields.DefaultForUsers]: true,
        [DashboardRow.Fields.Version]: true,
        [DashboardRow.Fields.RowId]: true,
        [DashboardRow.Fields.CreatedBy]: true,
        [DashboardRow.Fields.CreatedWhen]: true,
        [DashboardRow.Fields.UpdatedBy]: true,
        [DashboardRow.Fields.UpdatedWhen]: true,
    };

    @Serenity.Decorators.panel()
    @Serenity.Decorators.registerClass()
    export class DashboardDialog extends SiteEntityDialog<DashboardRow, any> {
        protected getFormKey() { return DashboardForm.formKey; }
        protected getIdProperty() { return DashboardRow.idProperty; }
        protected getLocalTextPrefix() { return DashboardRow.localTextPrefix; }
        protected getNameProperty() { return DashboardRow.Fields.Name; }
        protected getService() { return DashboardService.baseUrl; }
        protected getDeletePermission() { return DashboardRow.deletePermission; }
        protected getInsertPermission() { return DashboardRow.insertPermission; }
        protected getUpdatePermission() { return DashboardRow.updatePermission; }

        protected form = new DashboardForm(this.idPrefix);
        private dashboardEditor: DashboardEditor;

        constructor(opt: any) {
            super(opt);

            this.dashboardEditor = new DashboardEditor($(`<div id="${this.idPrefix}_DashboardContainer">`).insertAfter(this.form.Name.element.closest('.category')), {});

            this.dashboardEditor.element.on('widgetModified', this.updateBindingKeys.bind(this));
        }

        protected updateBindingKeys() {
            this.form.ParamBindingsOnToolbar["options"].items = this.dashboardEditor.getBindingKeys().slice();
            this.form.ParamBindingsOnToolbar.updateItems();
        }

        protected getSaveEntity() {
            var entity = super.getSaveEntity();
            entity.Data = {};

            for (var name of Object.keys(entity)) {
                if (dashboardTableFields[name])
                    continue;

                entity.Data[name] = entity[name];
                delete entity[name];
            }

            entity.Data.Items = this.dashboardEditor.value;

            return entity;
        }

        protected loadEntity(entity: DashboardRow) {
            if (entity != null && entity.Data != null) {
                for (var name of Object.keys(entity.Data)) {
                    if (dashboardTableFields[name])
                        continue;

                    entity[name] = entity.Data[name];
                }
            }

            this.dashboardEditor.paramBindingsOnToolbar = entity.ParamBindingsOnToolbar;
            this.dashboardEditor.value = entity.Data?.Items || [];

            super.loadEntity(entity);
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            this.updateBindingKeys();
        }

        protected getLoadByIdRequest(id) {
            var request = super.getLoadByIdRequest(id);

            request.IncludeColumns = request.IncludeColumns || [];
            request.IncludeColumns.push(DashboardRow.Fields.DefaultForRoles);
            request.IncludeColumns.push(DashboardRow.Fields.DefaultForUsers);

            return request;
        }

        protected useViewMode() {
            return false;
        }
    }
}